
<div *ngIf="loading ==true"
style="display: flex;flex-direction: column;align-items: center;justify-content: center;min-height: 600px;align-self: center;">
<mat-spinner></mat-spinner>
</div>

<mat-card *ngIf="loading !=true" style="margin-left: 10px;margin-right: 10px;margin-top: 30px;">
  <mat-card-title>{{'Setup Questions' | translate | async}}</mat-card-title>
  <mat-card-content style="padding-left: 10px;padding-right: 10px;">
    <div *ngIf="UpdatedList.length > 0">
      
      
      <mat-list role="list" *ngFor="let cat of UpdatedList;index as catIndex">
  
        <mat-list-item role="listitem">
          <div class="listItemContainer">
  
  
            <div class="ListTitleContainer">
              <span class="CatTitle">{{cat.Category.CategoryName}} </span>
              <button mat-button (click)="updateCategoryDialog(cat.Category)" class="crt">
                <mat-icon click>create</mat-icon>
              </button>
  
            </div>
            <!-- <div>
              <button mat-raised-button  class="crt">
                <mat-icon>keyboard_arrow_down</mat-icon>
              </button>
              <button mat-raised-button class="crt">
                <mat-icon>keyboard_arrow_up</mat-icon>
              </button>
            </div> -->
          </div>
  
        </mat-list-item>
  
        <mat-list role="list" *ngFor="let qus of cat.Questions; let i = index">
  
          <mat-list-item  role="listitem">
            <div class="SectionlistItemContainer">
              
              <div class="ListTitleContainer">
                <button mat-button (click)="ChangeActive(qus)" mat-icon->
                  <mat-icon *ngIf="qus.Active" style="color:green">done</mat-icon>
                  <mat-icon *ngIf="!qus.Active" style="color:red">close</mat-icon>
                </button>
                <span class="SectionTitle">{{qus.QuestionName}} </span>
                <button mat-button (click)="updateQuestionDialog(qus)" mat-icon->
                  <mat-icon>create</mat-icon>
                </button>
              </div>
  
              <div>
                <!-- <button mat-button class="crt" [disabled]="i+1 == this.questionlist.length"
                  >
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                <button mat-button class="crt" [disabled]="i == 0" (click)="SectionUp(qus.InductionType,qus.Order)">
                  <mat-icon>keyboard_arrow_up</mat-icon>
                </button> -->
              </div>
  
            </div>
          </mat-list-item>
  
          <mat-divider></mat-divider>
        </mat-list>
  
        <div class="addSectionButton">
          <button (click)="AddnewQuestionDialog(cat.Category)" mat-raised-button color="lightgray">
            <i class="material-icons alert__icon">add</i>
            {{"Add Question" | translate | async}}
          </button>
        </div>
  
  
      </mat-list>
    </div>
    
    
  </mat-card-content>

  <mat-card-actions>
    
          <button (click)="AddNewCategoryDialog()"  mat-raised-button color="lightgray">
            <mat-icon>add</mat-icon>Add New Category
          </button>    
      
  </mat-card-actions>

</mat-card>
